/**
 * Author: Romain Hapi, Prenim Ltd
 * Version: 1.0
 * Date: 2026-10-25
 * Project: Prenim Digital
 * Copyright: Prenim Ltd
 */
/**
 * Drapeau d'un pays, en image SVG servie depuis `public/images/flags/`.
 *
 * Les emoji de drapeaux (🇫🇷, 🇹🇩...) ne s'affichent pas sous Windows : Chrome et
 * Edge y montrent les deux lettres du code pays a la place. Une image s'affiche
 * partout de la meme facon.
 *
 * `code` est le code ISO du pays en minuscules (fr, gb, es, sa, td).
 */
import React from "react";

const Flag = ({ code, className = "" }) => (
  <img
    src={`/images/flags/${code}.svg`}
    alt=""
    aria-hidden="true"
    width="20"
    height="14"
    className={`inline-block h-3.5 w-5 rounded-[2px] object-cover shadow-sm ring-1 ring-black/10 ${className}`}
  />
);

export default Flag;
